<template>
  <div
    v-if="currentReason"
    class="mb-2"
    style="
      box-shadow: 3px 3px 6px 2px #eee;
      border-radius: 5px;
      border: 1px solid #d6d6d6;
      overflow: hidden;
    "
  >
    <div class="pa-2">
      <v-layout align-center wrap>
        <v-flex>
          <template v-if="isEdit">
            <v-text-field
              v-model="currentReason.reason"
              v-validate="'required'"
              :name="`reason_${timestamp}`"
              data-vv-as="reason"
              outline
              :hide-details="!errors.has(`reason_${timestamp}`)"
              :error="errors.has(`reason_${timestamp}`)"
              :error-messages="errors.first(`reason_${timestamp}`)"
              single-line
              :loading="loading"
            />
          </template>
          <template v-else> Level 1 {{ currentReason.reason }} </template>
        </v-flex>
        <v-flex shrink class="text-xs-right">
          <template v-if="!isEdit">
            <v-btn icon color="primary" @click="isEdit = true">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon color="error" @click="deleteReason">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-btn color="grey" outline :loading="loading" @click="handleAddLevel1">
              <v-icon class="mr-2">add</v-icon>
              {{ $t('Add') }}
            </v-btn>
            <v-btn color="grey" outline :loading="loading" @click="handleCancel">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn color="primary" :loading="loading" @click="handleSave">
              {{ $t('Save') }}
            </v-btn>
          </template>
          <v-btn icon @click="showMore = !showMore">
            <v-icon>{{ showMore ? 'expand_less' : 'expand_more' }}</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <template v-if="showMore">
      <div class="pa-2" style="background-color: #eee">
        <template v-for="(reasonRoute, index) in currentReason.reason_route">
          <div :key="`reason_route_${index}`" class="tree">
            <ReasonRoute
              :reason-route="reasonRoute"
              :parent-key="`${index}`"
              :is-edit="isEdit"
              @updateReasonRoute="handleUpdateReasonRoute(index, $event)"
              @onDeleteReasonRoute="handleDeleteSubReasonRoute(index)"
            />
          </div>
        </template>
        <div v-if="isEdit" class="text-xs-center my-2">
          <v-btn color="grey" outline :loading="loading" @click="handleCancel">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="primary" :loading="loading" @click="handleSave">
            {{ $t('Save') }}
          </v-btn>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { handleApiError } from '@/api/util'
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import reasonApi from '@/api/reason.js'
import ReasonMixin from './ReasonMixin'
import ReasonRoute from '@/components/view/template/ticket/Reason/ReasonRoute.vue'
export default {
  components: { ReasonRoute },
  mixins: [ReasonMixin],
  inject: ['$validator'],
  props: {
    reason: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showMore: false,
      isEdit: false,
      currentReason: undefined,
      cachedReason: undefined,
      loading: false,
      timestamp: moment().valueOf()
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.currentReason = cloneDeep(this.reason)
    this.cachedReason = cloneDeep(this.reason)
  },
  methods: {
    handleUpdateReasonRoute(index, data) {
      const reason = { ...this.currentReason }
      reason.reason_route[index] = data
      this.currentReason = reason
    },
    handleAddLevel1() {
      this.currentReason.reason_route.push({
        title: '',
        subReason: [],
        level: 1,
        name: 'level_1'
      })
    },
    handleCancel() {
      this.isEdit = false
      this.currentReason = cloneDeep(this.cachedReason)
    },
    async handleSave() {
      const result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.loading = true
      const saveResult = await this.handleSaveReason({
        pageId: this.selectedBot.pageid,
        currentReason: this.currentReason
      })
      if (saveResult) {
        this.isEdit = false
        this.cachedReason = cloneDeep(this.currentReason)
        this.$emit('updateReason', this.currentReason)
      }
      this.loading = false
    },
    async deleteReason() {
      await this.$swal
        .fire({
          title: this.$t('Do you want to delete this?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        .then(async (result) => {
          if (result.value) {
            this.$store.dispatch('loading')
            try {
              const response = await reasonApi.deleteReason({
                data: { page_id: this.selectedBot.pageid, id: this.currentReason.id }
              })
              if (response.status == 200 || response.status == 204) {
                this.$emit('deleteReason')
              }
            } catch (error) {
              handleApiError(error)
            } finally {
              this.$store.dispatch('clear_loading')
            }
          }
        })
    },
    handleDeleteSubReasonRoute(index) {
      this.currentReason.reason_route.splice(index, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ticket/Reason/ReasonItem.vue